
// Simple feature flags to control feature availability
export const featureFlags = {
  enableGoogleSignIn: true,
  // Flag to control whether subscription limits are enforced for prompt copies
  enableSubscriptionLimits: false,  // Set to false for alpha testing
  // Flag to control daily prompt copy limits per user per prompt
  enableDailyCopyLimit: true
};
